export const UNCLASSIFIED = 'unclassified';

export const humanizeName = name => name.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase());

export const humanizeCategory = category =>
  !category || category === UNCLASSIFIED ? 'Unclassified' : humanizeName(category).replace('Re Engagement', 'Re-engagement');
